import React from 'react'
import { IClaimBranch } from '@verzekeringapp-mono/shared/src/models/product'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import PolicySelector from './PolicySelector'
import SETTINGS from '@verzekeringapp-mono/shared/src/constants/settings'
import ContactInfoButton from '~/screens/advisor/components/contact_info_button'
import { useAppSelector } from '@verzekeringapp-mono/shared/src/hooks/state'
import {
  getAgency,
  getMainLocation
} from '@verzekeringapp-mono/shared/src/state/selectors/agency'
import { useEmergencyModalContext } from '~/providers/EmergencyModalProvider'

interface IProps {
  claimMethod: IClaimBranch
}
const ClaimDamageUnclaimable = ({ claimMethod }: IProps) => {
  const agency = useAppSelector(getAgency)
  const mainLocation = useAppSelector(getMainLocation)
  const { open } = useEmergencyModalContext()

  return (
    <div className='mx-auto flex w-full flex-wrap justify-between rounded-lg bg-surface-card p-8 lg:w-5/6'>
      <div className='w-full'>
        <h1 className='text-3xl font-medium mb-6 gap-8 flex items-center'>
          <span className='flex h-[50px] w-[50px] items-center justify-center rounded-full bg-surface-brand-subtle p-9'>
            <FontAwesomeIcon
              icon='fragile'
              className='text-icon-brand'
              size='xl'
            />
          </span>
          Schade melden
        </h1>

        <PolicySelector />

        <div className='my-4'>
          <p
            className='text-text-primary'
            dangerouslySetInnerHTML={{ __html: claimMethod.description }}
          />
        </div>
      </div>

      {agency && (
        <div>
          <div className='md:block flex justify-between md:justify-start'>
            <p className='mb-2 hidden md:block font-medium'>Direct contact?</p>

            <ContactInfoButton
              description={mainLocation?.phoneNumber}
              icon='phone'
              title={'Bellen'}
              href={`tel:${mainLocation?.phoneNumber}`}
            />

            <ContactInfoButton
              description={mainLocation?.email}
              icon='envelope'
              title={'Bericht'}
              href={`mailto:${mainLocation?.email}`}
            />

            <ContactInfoButton
              description={agency?.whatsappNumber}
              icon={['fab', 'whatsapp']}
              title={'WhatsApp'}
              variant='whatsapp'
              href={`https://wa.me/${agency?.whatsappNumber}`}
            />

            <ContactInfoButton
              icon={['fas', 'globe']}
              title={'Website'}
              description={agency.website}
              href={
                agency?.website
                  ? agency.website.startsWith('http')
                    ? agency.website
                    : `https://${agency.website}`
                  : undefined
              }
            />

            <ContactInfoButton
              description={SETTINGS.emergencyPhoneNumber}
              icon='phone-plus'
              title={'Nood'}
              variant='danger'
              onClick={open}
            />
          </div>
        </div>
      )}
    </div>
  )
}

export default ClaimDamageUnclaimable
